import { Box } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import Link from "@mui/material/Link";
import { isEmpty, getDirectLinkExam } from "../../../utils/helpers/helpers";
import { eventTracking } from "../../../firebase/firebaseConfig";

function LessonRelated({ relatedLesson }) {
  if (isEmpty(relatedLesson)) return null;
  const totalArray = relatedLesson?.lesson_front.concat(relatedLesson?.lesson_behind);
  const half = Math.ceil(totalArray.length / 2);

  const firstHalf = totalArray.slice(0, half);
  const secondHalf = totalArray.slice(-half);
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: 16
      }}
    >
      <Box
        style={{
          display: "flex"
        }}
      >
        <span className="text-[20px] font-bold">
          <FormattedMessage id="IDS_Related_Lesson" />
        </span>
      </Box>
      <Box style={{ marginTop: 12 }} display="flex" justifyContent="space-between">
        {!isEmpty(firstHalf) && (
          <Box style={{ width: "45%" }} display="flex" flexDirection="column">
            {firstHalf.map((ele, idx) => (
              <Link
                key={`${idx}`}
                style={{ textDecoration: "unset", color: "black" }}
                href={getDirectLinkExam(ele.direct_link_slug)}
                onClick={() => eventTracking("select_lesson_relate_item")}
              >
                <span style={{ marginBottom: 8, color: "black" }}>{ele.title}</span>
              </Link>
            ))}
          </Box>
        )}
        {!isEmpty(secondHalf) && (
          <Box style={{ width: "45%" }} display="flex" flexDirection="column">
            {secondHalf.map((ele, idx) => (
              <Link
                key={`${idx}`}
                style={{ textDecoration: "unset", color: "black" }}
                href={getDirectLinkExam(ele.direct_link_slug)}
                onClick={() => eventTracking("select_lesson_relate_item")}
              >
                <span style={{ marginBottom: 8, color: "black" }}>{ele.title}</span>
              </Link>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default React.memo(LessonRelated);
